import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AdminLayout } from "./components/admin/AdminLayout";
import { AdminDashboard } from "./pages/admin/AdminDashboard";
import { WashBookings } from "./pages/admin/WashBookings";
import { ProductOrders } from "./pages/admin/ProductOrders";
import { ProductsPanel } from "./pages/admin/ProductsPanel";
import { WashesPanel } from "./pages/admin/WashesPanel";
import { AdminSettings } from "./pages/admin/AdminSettings";
import { UsersPanel } from "./pages/admin/UsersPanel";
import { LocationsPanel } from "./pages/admin/LocationsPanel";

export function AdminApp() {
  const location = useLocation();
  if (!location.pathname.startsWith("/admin")) {
    return <Navigate to="/admin" replace />;
  }

  return (
    <AdminLayout>
      <Routes>
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/bookings" element={<WashBookings />} />
        <Route path="admin/bookings/:id" element={<WashBookings />} />
        <Route path="/admin/orders" element={<ProductOrders />} />
        <Route path="admin/orders/:id" element={<ProductOrders />} />
        <Route path="/admin/products" element={<ProductsPanel />} />
        <Route path="admin/products/:id" element={<ProductsPanel />} />
        <Route path="/admin/washes" element={<WashesPanel />} />
        <Route path="admin/washes/:id" element={<WashesPanel />} />
        <Route path="/admin/settings" element={<AdminSettings />} />
        <Route path="/admin/users" element={<UsersPanel />} />
        <Route path="/admin/locations" element={<LocationsPanel />} />
        <Route path="/admin/cars" element={<div>Cars Page</div>} />
      </Routes>
    </AdminLayout>
  );
}
